<template>
  <b-card
    no-body
    class="container-card p-2 card-create information-card"
    id="campaign-entry-list"
  >
    <div v-if="privilegeEntryList.payload.length == 0">
      <content-no-item
        :text-no-img="'Privilege'"
        :is-disabled="!isEdit"
        :action-func="onOpenAddPrivilege"
      />
      <label class="campaign-show-desc text-center" v-if="!isEdit">
        กรุณาสร้างแคมเปญก่อนเพิ่มของรางวัล
      </label>
    </div>
    <b-row v-else>
      <b-col cols="12">
        <div>
          <div class="d-flex justify-content-end mb-1">
            <add-button
              :btn-label="'Privilege'"
              @click.native="onOpenAddPrivilege"
            />
          </div>
          <div class="d-flex flex-wrap justify-content-end">
            <div class="mr-1 ml-1 mb-1">
              <v-select
                id="campaign-type-status"
                class="v-select-filter bg-document-list bg-dropdown"
                :class="status ? 'v-select-filter-selected' : null"
                placeholder="Status"
                :options="statusOption"
                @input="(option) => onSelectFilter('status', option)"
              />
            </div>

            <div class="search-container mb-1">
              <search :on-search-input="onSetValueSearch" />
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" class="mb-1">
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :key="tableModeReorder + keyChange"
              v-sortable-row="sortableRowOptions"
              :fields="fields"
              :items="privilegeEntryList.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              class="default-static-table"
              :class="tableModeReorder ? 'table-reorder' : null"
            >
              <template #head(pv_image_url)="data">
                <div class="text-center">
                  {{ data.label }}
                </div>
              </template>
              <template #cell(pv_image_url)="data">
                <div class="text-center">
                  <img :src="data.value || DefaultImg" class="image-column" />
                </div>
              </template>
              <template #head(pv_name_th)="data">
                <div class="text-left">
                  {{ data.label }}
                </div>
              </template>
              <template #cell(pv_valid_from)="data">
                <span>{{
                  data.item.pv_valid_from
                    ? resolveDateWithSeperator(data.item.pv_valid_from)
                    : "-"
                }}</span>
              </template>
              <template #cell(pv_valid_through)="data">
                <span>{{
                  data.item.pv_valid_through
                    ? resolveDateWithSeperator(data.item.pv_valid_through)
                    : "-"
                }}</span>
              </template>
              <template #cell(pv_status)="data">
                <div class="d-flex align-items-center">
                  <feather-icon
                    icon="CircleIcon"
                    class="mr-2"
                    :class="resolveStatusClass(data.value)"
                  />

                  <span>{{ resolveStatusLabel(data.value) }}</span>
                </div>
              </template>
              <template #cell(status)="data">
                <b-form-checkbox
                  field-value="true"
                  class="custom-control-success custom-toggle"
                  name="check-button"
                  switch
                  :checked="data.item.status == 1"
                  @change="changeEntryStatus(data.item, $event)"
                >
                  <span class="switch-icon-left toggle-text">{{ "" }}</span>
                  <span class="switch-icon-right toggle-text">{{ "" }}</span>
                </b-form-checkbox>
              </template>
              <template #cell(actions)="data">
                <action-group
                  :resolve-action="resolveMappingTableAction"
                  :set-action-list="privilegeActionList"
                  :item-data="data"
                />
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          entity-editable
          reordering
          :pagination="pagination"
          @reorder="onClickReorder"
          @entityChange="onFilterEntity"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
    <reorder-modal
      v-if="modalType.reorder"
      :current-index="currentIndex"
      :reorder-action="reorderPrivilege"
      @onCloseModal="() => (modalType.reorder = false)"
    />
    <edit-add-privilege-info
      :privilegeObj="privilegeEditSelect"
      v-if="modalType.editModal"
      @onCloseEditModal="closeEditModal"
      @editPrivilege="fetchEntryEdit"
    />
  </b-card>
</template>

<script>
import ContentNoItem from "@/@core/components/card-no-item/ContentNoItem.vue";
import useCampaignEntryList from "../hooks/useCampaignEntryList";
import AddButton from "@/views/components/button/AddButton.vue";
import vSelect from "vue-select";
import Search from "@/views/components/search/Search.vue";
import CardNoItem from "@/@core/components/card-no-item/CardNoItem.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import ReorderModal from "@/@core/components/reorder-modal/ReorderModal.vue";
import Sortable from "sortablejs";
import EditAddPrivilegeInfo from "../modal/EditAddPrivilegeInfo.vue";

const createSortable = (el, options, vnode) =>
  Sortable.create(el, {
    ...options,
  });

const sortableRow = {
  name: "sortableRow",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
};

export default {
  directives: {
    sortableRow,
  },
  components: {
    ContentNoItem,
    AddButton,
    vSelect,
    Search,
    CardNoItem,
    PaginationWithReorder,
    ActionGroup,
    ReorderModal,
    EditAddPrivilegeInfo,
  },
  props: {
    isEdit: { type: Boolean, default: false },
    onOpenAddPrivilege: { type: Function, default: () => {} },
  },
  setup() {
    const {
      modalType,
      fields,
      loading,
      status,
      statusOption,
      privilegeEntryList,
      filters,
      ordering,
      pagination,
      privilegeActionList,
      sortableRowOptions,
      tableModeReorder,
      keyChange,
      currentIndex,
      reorderPrivilege,
      privilegeEditSelect,
      onSetValueSearch,
      onSelectFilter,
      onPageChange,
      onFilterEntity,
      resolveDateWithSeperator,
      resolveTime,
      removeCampaign,
      resolveStatusClass,
      resolveStatusLabel,
      resolveMappingTableAction,
      onClickReorder,
      closeEditModal,
      changeEntryStatus,
      fetchEntryEdit,
      fetchEntryList,
    } = useCampaignEntryList();
    return {
      modalType,
      DefaultImg,
      fields,
      loading,
      status,
      statusOption,
      privilegeEntryList,
      filters,
      ordering,
      pagination,
      privilegeActionList,
      sortableRowOptions,
      tableModeReorder,
      keyChange,
      currentIndex,
      reorderPrivilege,
      privilegeEditSelect,
      onSetValueSearch,
      onSelectFilter,
      onPageChange,
      onFilterEntity,
      resolveDateWithSeperator,
      resolveTime,
      removeCampaign,
      resolveStatusClass,
      resolveStatusLabel,
      resolveMappingTableAction,
      onClickReorder,
      closeEditModal,
      changeEntryStatus,
      fetchEntryEdit,
      fetchEntryList,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";
#campaign-entry-list .campaign-show-desc {
  font-size: 22px;
  color: red;
  display: flex;
  justify-content: center;
}

#campaign-entry-list .custom-toggle {
  width: 50px;
}
</style>
